export default {
	title: 'Stakes',
	url: 'stakes',
	no_description: 'No defined goal',
	context_worse: 'Negative',
	context_best: 'Positive',
	tabs: {
		filters: {
			title: 'View filters'
		},
		general: {
			title: 'General'
		},
		export: {
			title: 'Export'
		},
		comments: {
			title: 'History'
		},
		bot: {
			title: 'AI'
		}
	},
	messages: {
		edit_stake: 'Stake edition',
		create_stake: 'Create a new stake'
	},
	onboarding: {
		title: 'Review your stakes',
		description:
			"The AI has identified the structural stakes of your topic. Check that they really capture what you could lose or gain if nothing is done. Adjust, remove or add as needed."
	}
};
